import React from 'react'
import PropTypes from 'prop-types'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import ContentfulButtonV3 from '../Utilities/Buttons/V3/ContentfulButtonV3'

function PressCardV3({ data }) {
  const { headerImage, description, button } = data
  return (
    <div className="press-kit__logo-box">
      <div className="press-kit__photo-box">
        <GatsbyImage image={getImage(headerImage.image)} alt={headerImage?.altText} />
        <p className="press-kit__description">{description?.description}</p>
      </div>
      {button && <ContentfulButtonV3 data={button} oldPimary className="press-kit__button" />}
    </div>
  )
}
PressCardV3.propTypes = {
  data: PropTypes.object.isRequired
}

export default PressCardV3
